function formatDate(date, format) {
    if (!(date instanceof Date)) {
        return;
    }

    const DD = String(date.getDate()).padStart(2, "0");
    const MM = String(date.getMonth() + 1).padStart(2, "0");
    const YYYY = date.getYear() + 1900;

    switch (format) {
        case "DD-MM-YYYY":
            return `${DD}-${MM}-${YYYY}`;
        case "MM-DD-YYYY":
            return `${MM}-${DD}-${YYYY}`;
        case "YYYY-MM-DD":
        default:
            return `${YYYY}-${MM}-${DD}`;
    }
}

export default formatDate;
